
let _url = {

    getParam: function (k) {

        const url = window.location.href
        const encode = new RegExp('[?|&]' + k + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""]
        return decodeURIComponent((encode)[1].replace(/\+/g, '%20')) || '';
    }
}

export default _url
